export default {
    setLang(state, value) {
        state.i_lang = value;
    },
};